import type { ReactNode } from "react"
import { cn } from "@/shared/lib/utils"

interface SectionHeadingProps {
	title: string
	trailing?: ReactNode
	className?: string
}

export function SectionHeading({ title, trailing, className }: SectionHeadingProps) {
	return (
		<div className={cn("mb-4 flex items-baseline justify-between gap-3", className)}>
			<h2 className="min-w-0 truncate text-lg font-semibold tracking-tight">{title}</h2>
			{trailing}
		</div>
	)
}
